// Reusable legal-content shell — pass a title and children.
export default function LegalPage({ title, updated, children, testId }) {
  return (
    <article className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28 prose-legal" data-testid={testId}>
      <div className="overline">Legal</div>
      <h1 className="display text-5xl md:text-6xl mt-4">{title}</h1>
      {updated && <p className="text-xs text-muted2 mt-4 tracking-wide uppercase">Last updated · {updated}</p>}
      <div className="hairline my-10" />
      <div className="text-base leading-relaxed space-y-5 [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-3 [&_p]:text-charcoal/85 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_a]:text-terra [&_a]:underline">
        {children}
      </div>
    </article>
  );
}
